import { createHourlyConfig, updateHourlyConfig } from "./api";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { invalidateJobQueries } from "components/job/queries";

export function useCreateHourlyConfig({ onSuccess }) {
  return useMutation({
    mutationFn: async ({ jobId, values }) => {
      return await createHourlyConfig({ jobId, values });
    },
    onSuccess: () => {
      toast.success("Config created successfully");
      invalidateJobQueries();

      // onSuccess();
    },
    onError: (err) => {
      toast.error(err.message || "Failed to create config");
      console.error(err);
    },
  });
}

export function useUpdateHourlyConfig() {
  return useMutation({
    mutationFn: async ({ id, values }) => {
      return await updateHourlyConfig({ id, values });
    },
    onSuccess: () => {
      toast.success("Config updated successfully");
      invalidateJobQueries();
    },
    onError: (err) => {
      toast.error(err.message || "Failed to update config");
      console.error(err);
    },
  });
}
